import { DateField, TradeCompanySiteAutocomplete, TradeCompanySiteSelector, useWatch } from 'form';
import { SectionContainer } from 'ui';

import type { CreateFormValues } from '../../pages/PurchaseOrderCreate/PurchaseOrderCreate';
import { IncotermSpecificFields } from '../IncotermSpecificFields/IncotermSpecificFields';
import { TransportMethod } from '../TransportMethod/TransportMethod';

export const SellerLogisticsSection = () => {
  const { seller_id, producer_id, incoterm } = useWatch<CreateFormValues>();

  return (
    <SectionContainer title="Logistics">
      <TradeCompanySiteSelector
        name="production_site_id"
        label="Production site"
        tradeCompanyId={producer_id}
        disabled={true}
        required
        infoTooltip="Actual address of the site the material was produced."
      />
      <TradeCompanySiteAutocomplete
        name="collection_site_id"
        label="Collection site"
        tradeCompanies={[seller_id, producer_id].filter((value) => value !== null && value !== undefined)}
        required
        infoTooltip="Actual address of the loading site. Also, the address of where the inspection will take place."
      />
      <DateField
        name="target_collection_date"
        label="Target collection date"
        required
        infoTooltip="Date, committed to by the seller, by which the material will be ready for collection from seller's site."
        fullWidth
      />
      <TransportMethod required />
      <IncotermSpecificFields incoterm={incoterm} />
    </SectionContainer>
  );
};
